/* La FAQ racontée par Yumi (snippets/yc-faq-yumi.liquid) : tout l'habillage est fabriqué ici, dans le navigateur ;
   le code de la page (lu par Google et les IA) ne contient que la FAQ d'origine. */
  (function () {
    var bloc = document.currentScript && document.currentScript.previousElementSibling;
    if (!bloc || !bloc.matches('[data-yc-faq-yumi]')) return;
    var tiroir = bloc.closest('details');
    var liste = tiroir && tiroir.querySelector('.yc-faq');
    if (!liste) return;
    var items = Array.prototype.slice.call(liste.querySelectorAll('.yc-faq__item')).map(function (it) {
      var q = it.querySelector('.yc-faq__q'), a = it.querySelector('.yc-faq__a');
      return q && a ? { q: q.textContent.trim(), a: a.textContent.trim() } : null;
    }).filter(Boolean);
    if (items.length < 2) return;
    var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var avatar = bloc.getAttribute('data-avatar');
    bloc.innerHTML = '<div class="yc-fy__tete"><img class="yc-fy__avatar" alt="" width="40" height="40">'
      + '<span class="yc-fy__qui"><b>Yumi <em><i aria-hidden="true"></i>en ligne</em></b><small>PDG de Yumi &amp; Cie</small></span></div>'
      + '<div class="yc-fy__fil" aria-live="polite"></div><div class="yc-fy__puces" role="list" aria-label="Questions fréquentes"></div>';
    bloc.querySelector('.yc-fy__avatar').src = avatar;
    var fil = bloc.querySelector('.yc-fy__fil'), puces = bloc.querySelector('.yc-fy__puces');
    var tour = 0, accueilli = false, ouvert = false, VISIBLES = 3;
    var posees = [];

    // une réponse de la fiche, en phrases (une bulle par phrase, deux phrases courtes peuvent partager une bulle)
    function phrases(t) {
      var p = t.match(/[^.!?…]+(?:[.!?…]+|$)/g) || [t];
      var out = [], courts = [];
      // une phrase longue se coupe à ses deux-points ou points-virgules : deux bulles courtes se lisent mieux qu'un pavé
      p.forEach(function (s) {
        s = s.trim();
        var m = s.length > 90 && s.match(/^(.{20,}?)\s*([:;])\s+(.{20,})$/);
        if (m) { courts.push(m[1] + (m[2] === ':' ? ' :' : '')); courts.push(m[3]); } else if (s) courts.push(s);
      });
      courts.forEach(function (s) {
        var der = out[out.length - 1];
        if (der && der.length + s.length < 70) out[out.length - 1] = der + ' ' + s; else out.push(s);
      });
      return out;
    }
    function ligne(qui) {
      var l = document.createElement('div');
      l.className = 'yc-fy__ligne yc-fy__ligne--' + qui;
      if (qui === 'yumi') {
        var im = document.createElement('img');
        im.className = 'yc-fy__mini'; im.src = avatar; im.alt = ''; im.width = 28; im.height = 28;
        l.appendChild(im);
      }
      var b = document.createElement('div');
      b.className = 'yc-fy__bulles';
      l.appendChild(b);
      fil.appendChild(l);
      return b;
    }
    function bulle(dans, texte) {
      var p = document.createElement('p');
      p.className = 'yc-fy__bulle';
      p.textContent = texte;
      dans.appendChild(p);
      defiler();
      return p;
    }
    function points(dans) {
      var p = document.createElement('p');
      p.className = 'yc-fy__bulle yc-fy__pense';
      p.setAttribute('aria-label', 'Yumi écrit');
      p.innerHTML = '<i></i><i></i><i></i>';
      dans.appendChild(p);
      defiler();
      return p;
    }
    function defiler() { fil.scrollTop = fil.scrollHeight; }
    // Yumi écrit ses phrases l'une après l'autre ; une nouvelle question coupe la réponse en cours
    function ecrire(textes, n) {
      var dans = ligne('yumi'), k = 0;
      (function suite() {
        if (n !== tour || k >= textes.length) return;
        var p = points(dans);
        setTimeout(function () {
          if (n !== tour) { p.remove(); return; }
          p.remove(); bulle(dans, textes[k++]); suite();
        }, reduit ? 0 : 450 + Math.min(500, textes[k].length * 6));
      })();
    }
    // les questions restantes : une question posée disparaît pour de bon (sa réponse reste au-dessus) ; 3 visibles,
    // les autres derrière « + N autres questions » ; tout posé : un lien pour les revoir toutes
    function majPuces(posee) {
      if (posee) posees.push(posee);
      var reste = [];
      puces.querySelectorAll('.yc-fy__puce').forEach(function (b) {
        b.classList.remove('est-or');
        if (posees.indexOf(b) >= 0) { b.hidden = true; return; }
        reste.push(b);
        b.hidden = !ouvert && reste.length > VISIBLES;
      });
      var cache = reste.length - VISIBLES;
      plus.hidden = ouvert || cache <= 0;
      plus.textContent = '+ ' + cache + (cache > 1 ? ' autres questions' : ' autre question');
      revoir.hidden = reste.length > 0;
      if (reste[0]) reste[0].classList.add('est-or');
    }
    function repondre(i, bouton) {
      var n = ++tour;
      bulle(ligne('vous'), items[i].q);
      majPuces(bouton);
      ecrire(phrases(items[i].a), n);
    }
    function accueil() {
      if (accueilli) return;
      accueilli = true;
      ecrire(['Bonjour, je peux vous aider ?', 'Choisissez votre question, je suis dispo.'], tour);
    }

    items.forEach(function (it, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'yc-fy__puce' + (i ? '' : ' est-or');
      b.setAttribute('role', 'listitem');
      b.textContent = it.q;
      b.addEventListener('click', function () { repondre(i, b); });
      puces.appendChild(b);
    });
    var plus = document.createElement('button');
    plus.type = 'button'; plus.className = 'yc-fy__plus';
    plus.addEventListener('click', function () { ouvert = true; majPuces(); });
    puces.appendChild(plus);
    var revoir = document.createElement('button');
    revoir.type = 'button'; revoir.className = 'yc-fy__plus'; revoir.textContent = 'Revoir toutes les questions';
    revoir.addEventListener('click', function () { posees = []; ouvert = false; majPuces(); });
    puces.appendChild(revoir);
    majPuces();
    // le fond ambre suit la souris et le clavier : il quitte la question présélectionnée pour celle qu'on survole
    var suivre = function (e) {
      var p = e.target.closest && e.target.closest('.yc-fy__puce');
      if (!p) return;
      puces.querySelectorAll('.yc-fy__puce').forEach(function (x) { x.classList.toggle('est-or', x === p); });
    };
    puces.addEventListener('pointerover', suivre);
    puces.addEventListener('focusin', suivre);

    liste.classList.add('yc-faq--yumi');
    bloc.hidden = false;
    tiroir.addEventListener('toggle', function () { if (tiroir.open) accueil(); });
    if (tiroir.open) accueil();
  })();
